import Vue from 'vue'
import Router from 'vue-router'
import { searchMenuCode } from '@/util/common'
import store from '@/store/index'
import { getSession, delSession, getQueryVariable } from '@/api/common'
import { set } from 'lodash'

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/newIndex/newHome',
    },
    // 登录页面
    {
      path: '/Login',
      name: 'Login',
      props: { name: 'code', name2: 'state' },
      component: () => import('@/views/auth/Login.vue'),
    },
    {
      path: '/newIndex',
      component: () => import('@/components/new-base/Index.vue'),
      children: [
        // 首页
        {
          path: '/newIndex/newHome',
          component: () => import('@/views/new-home/Index.vue'),
          meta: ['sys:new'],
        },
        // 设备管理
        {
          path: '/newIndex/newDevice',
          component: () => import('@/views/new-device/Index.vue'),
          meta: ['sys:new:device'],
          name: 'device',
        },
        // 人员管理
        {
          path: '/newIndex/new-person',
          component: () => import('@/views/new-set/Index.vue'),
          meta: ['sys:new:person'],
          redirect: '/mobileData',
          name: 'new-person',
          children: [
            {
              path: '/newIndex/new-person/Index',
              component: () => import('@/views/new-person/Index.vue'),
              meta: ['sys:new:person'],
              name: 'person',
            },
            {
              path: '/newIndex/new-person/ActivityStatistics',
              component: () => import('@/views/new-person/ActivityStatistics.vue'),
              meta: ['sys:new:person:activityStatistics'],
              name: 'ActivityStatistics',
            },
            {
              path: '/newIndex/new-person/DataStatistics',
              component: () => import('@/views/new-person/DataStatistics.vue'),
              meta: ['sys:new:person:dataStatistics'],
              name: 'DataStatistics',
            },
            {
              path: '/newIndex/new-person/EntryExitStatistics',
              component: () => import('@/views/new-person/EntryExitStatistics.vue'),
              meta: ['sys:new:person:entryExitStatistics'],
              name: 'EntryExitStatistics',
            },
          ],
        },
        // 监控中心
        {
          path: '/newIndex/newMonitor',
          component: () => import('@/views/new-monitor/Index.vue'),
          meta: ['sys:new:monitor'],
          name: 'monitor',
        },
        // 精准调度
        {
          path: '/newIndex/newCommand',
          component: () => import('@/views/new-command/Index.vue'),
          meta: ['sys:new:command'],
          name: 'command',
        },
        // 焦点关注
        {
          path: '/newIndex/newFocus',
          component: () => import('@/views/new-focus/Index.vue'),
          meta: ['sys:new:focus'],
          name: 'focus',
        },
        // 对讲中心
        {
          path: '/newIndex/newComunicate',
          component: () => import('@/views/new-comunicate/Index.vue'),
          meta: ['sys:new:comunicate'],
          name: 'comunicate',
        },
        // 告警中心
        {
          path: '/newIndex/newWarn',
          component: () => import('@/views/new-warn/Index.vue'),
          meta: ['sys:new:warn'],
          name: 'warn',
        },
        {
          path: '/newIndex/CheckMore',
          component: () => import('@/views/new-more/CheckMore.vue'),
          meta: ['查看更多'],
        },
        // 版本升级记录
        {
          path: '/newIndex/version',
          name: 'NewVersion',
          component: () => import('@/views/version/Index.vue'),
          meta: ['sys:new'],
        },
        // 数据中心，非直接地址
        {
          path: '/newIndex/newSet',
          component: () => import('@/views/new-set/Index.vue'),
          meta: ['sys:new:setting'],
          redirect: '/mobileData',
          name: 'set',
          children: [
            {
              path: '/newIndex/newSet/caution',
              component: () => import('@/views/new-set/data-center/Caution.vue'),
              meta: ['sys:new:setting:log:alert'],
              name: 'Caution',
            },
            {
              path: '/newIndex/newSet/mobileData',
              component: () => import('@/views/new-set/data-center/MobileData.vue'),
              meta: ['sys:new:setting:log:mobileData'],
            },
            {
              path: '/newIndex/newSet/battery',
              component: () => import('@/views/new-set/data-center/Battery.vue'),
              meta: ['sys:new:setting:log:battery'],
            },
            {
              path: '/newIndex/newSet/call',
              component: () => import('@/views/new-set/data-center/Call.vue'),
              meta: ['sys:new:setting:log:call'],
            },
            {
              path: '/newIndex/newSet/mediaUpload',
              component: () => import('@/views/new-set/data-center/MediaUpload.vue'),
              meta: ['sys:new:setting:log:media'],
            },
            {
              path: '/newIndex/newSet/modules',
              component: () => import('@/views/new-set/data-center/Modules.vue'),
              meta: ['sys:new:setting:log:module'],
            },
            {
              path: '/newIndex/newSet/Voiceprint',
              component: () => import('@/views/new-set/data-center/Voiceprint.vue'),
              meta: ['sys:new:setting:log:voiceDetect'],
            },
            {
              path: '/newIndex/newSet/Faceprint',
              component: () => import('@/views/new-set/data-center/Faceprint.vue'),
              meta: ['sys:new:setting:log:faceDetect'],
            },
            {
              path: '/newIndex/newSet/operation',
              component: () => import('@/views/new-set/data-center/OperationRecord.vue'),
              meta: ['sys:new:setting:log:operation'],
            },
            {
              path: '/newIndex/newSet/geoFence',
              component: () => import('@/views/new-set/data-center/GeoFenceRecord.vue'),
              meta: ['sys:new:setting:log:geoFence'],
            },
            {
              path: '/newIndex/newSet/sos',
              component: () => import('@/views/new-set/data-center/LogEmergencyHelp.vue'),
              meta: ['sys:new:setting:log:emergencyHelp'],
            },
            {
              path: '/newIndex/newSet/statistics',
              component: () => import('@/views/new-set/data-center/Statistics.vue'),
              meta: ['sys:new:setting:log:static'],
            },
            {
              path: '/newIndex/newSet/fence',
              component: () => import('@/views/new-set/sys-setting/Fence.vue'),
              meta: ['sys:new:setting:application:geofence'],
            },
            {
              path: '/newIndex/newSet/sysProperty',
              component: () => import('@/views/new-set/sys-setting/SysProperty.vue'),
              meta: ['sys:new:setting:device:config'],
            },
            {
              path: '/newIndex/newSet/message',
              component: () => import('@/views/new-set/sys-setting/Message.vue'),
              meta: ['sys:new:setting:device:ouSetting'],
            },
            {
              path: '/newIndex/newSet/tenantSet',
              component: () => import('@/views/new-set/sys-setting/TenantSet.vue'),
              meta: ['TenantSet'],
            },
            {
              path: '/newIndex/newSet/helmet_permissions',
              component: () => import('@/views/new-set/sys-setting/HelmetPermissions.vue'),
              meta: ['helmet_permissions'],
            },
            {
              path: '/newIndex/newSet/appUpgrade',
              component: () => import('@/views/new-set/sys-setting/AppUpgrade.vue'),
              meta: ['app_upgrade'],
            },
            {
              path: '/newIndex/newSet/SecretManage',
              component: () => import('@/views/new-set/sys-setting/SecretManage.vue'),
              meta: ['SecretManage'],
            },
            {
              path: '/newIndex/newSet/qaManage',
              component: () => import('@/views/new-set/sys-setting/QAManage.vue'),
              meta: ['qaManage'],
            },
            {
              path: '/newIndex/newSet/aiAnalysisManage',
              component: () => import('@/views/new-set/sys-setting/AIAnalysisManage.vue'),
              meta: ['sys:new:setting:system:ai'],
            },
            {
              path: '/newIndex/newSet/face',
              component: () => import('@/views/new-set/sys-setting/FaceRecognition.vue'),
              meta: ['sys:new:setting:application:face'],
            },
            {
              path: '/newIndex/newSet/voice',
              component: () => import('@/views/new-set/sys-setting/VoiceRecognition.vue'),
              meta: ['sys:new:setting:application:voice'],
            },
            {
              path: '/newIndex/newSet/wifi',
              component: () => import('@/views/new-set/sys-setting/WifiManagement.vue'),
              meta: ['sys:new:setting:system:wifi'],
            },
            {
              path: '/newIndex/newSet/userManage',
              component: () => import('@/views/new-set/sys-manage/UserManage.vue'),
              meta: ['sys:new:setting:system:user'],
            },
            {
              path: '/newIndex/newSet/rolesManage',
              component: () => import('@/views/new-set/sys-manage/RolesManage.vue'),
              meta: ['sys:new:setting:system:role'],
            },
            {
              path: '/newIndex/newSet/deviceList',
              component: () => import('@/views/new-set/device-manage/HelmetManage.vue'),
              meta: ['sys:new:setting:device'],
            },
            {
              path: '/newIndex/newSet/personal',
              component: () => import('@/views/new-set/personal-setting/Personal.vue'),
              meta: ['sys:new'],
            },
            {
              path: '/newIndex/newSet/personal',
              component: () => import('@/views/new-set/personal-setting/Personal.vue'),
              meta: ['sys:new'],
            },
            //考勤记录
            {
              path: '/newIndex/newSet/AttRecord',
              component: () => import('@/views/new-set/data-center/AttRecord.vue'),
              meta: ['sys:new:setting:log:workRecord'],
            },
            //类别配置
            {
              path: '/newIndex/newSet/CategoryConfig',
              component: () => import('@/views/new-set/device-manage/CategoryConfig.vue'),
              meta: ['sys:new:setting:device:mediaType'],
            },
            //模式切换记录
            {
              path: '/newIndex/newSet/ModeSwitching',
              component: () => import('@/views/new-set/data-center/ModeSwitching.vue'),
              meta: ['sys:new:setting:log:mode'],
            },
          ],
        },
        // 无权限页面
        {
          path: '/newIndex/Error',
          component: () => import('@/views/auth/Error.vue'),
          meta: ['error'],
        },
        // 图像检索
        {
          path: '/newIndex/imageRetrieval',
          component: () => import('@/views/image-retrieval/Index.vue'),
          meta: ['sys:new:warn'],
          name: 'images',
        },
        // 数据中心-媒体数据
        {
          path: '/newIndex/mediaData',
          component: () => import('@/views/new-dataMange/Index.vue'),
          meta: ['sys:new:data'],
          name: 'dataCenter',
        },
        // 数据中心-设备数据
        {
          path: '/newIndex/deviceData',
          component: () => import('@/views/new-dataMange/DeviceData.vue'),
          meta: ['sys:new:data:device'],
          name: 'dataCenter',
        },
        // 集成系统菜单
        {
          path: '/newIndex/newSet/systemManage',
          component: () => import('@/views/new-set/sys-manage/IntSystemManage.vue'),
          meta: ['sys:new:setting:system:user'],
        },
        // 公共系统菜单
        {
          path: '/newIndex/systems',
          component: () => import('@/views/integration/Index.vue'),
          meta: ['sys:new:setting:system:user'],
        },
        // 管控柜
        {
          path: '/newIndex/controlCabinet',
          component: () => import('@/views/controlCabinet/Index.vue'),
          meta: ['sys:new:monitor'],
        },
        //AI分析
        {
          path: '/newIndex/aiAnalysis',
          component: () => import('@/views/aiAnalysis/Index.vue'),
          meta: ['sys:new:monitor:ai'],
        },
      ],
    },
    {
      path: '/version',
      component: () => import('@/views/version/version.vue'),
    },
    {
      path: '/Access',
      component: () => import('@/views/auth/Access.vue'),
    },
    {
      path: '/download',
      component: () => import('@/components/download/Download.vue'),
      meta: ['download'],
    },
    {
      path: '/realvideo',
      component: () => import('@/components/realVideoFrame/RealVideoFrame.vue'),
      meta: ['realvideo'],
    },
    {
      path: '/Intercom',
      component: () => import('@/components/intercom/Intercom.vue'),
      meta: ['Intercom'],
    },
    {
      path: '/externalHistory',
      component: () => import('@/components/external-history/Index.vue'),
      meta: ['externalHistory'],
    },
    {
      path: '/monitor',
      component: () => import('@/components/monitorFrame/Index.vue'),
      meta: ['monitor'],
    },
    // 任何未匹配地址都会跳转到首页
    {
      path: '*',
      redirect: '/',
    },
  ],
})
// 路由跳转判断是否是免密登录
let freeLogin = getQueryVariable('appKey')
// // 全局导航钩子
router.beforeEach((to, from, next) => {
  console.log('to', to.path, 'from', from.path, freeLogin)
  if (to.path === '/Login') {
    delSession('access_token')
  }
  if (getSession('access_token')) {
    if (freeLogin) {
      setTimeout(() => {
        next()
      }, 200)
    } else if (searchMenuCode(to.meta[0], from.path) || to.path.includes('dmp') || to.path === '/version') {
      // 路由跳转判断是否有权限
      next()
    } else {
      next('/newIndex/Error')
    }
  } else {
    if (
      to.path === '/Login' ||
      to.path === '/404' ||
      to.path === '/realvideo' ||
      to.path === '/download' ||
      to.path.includes('dmp') ||
      to.path === '/Intercom' ||
      to.path === '/externalHistory' ||
      to.path === '/monitor'
    ) {
      next()
    } else {
      // 仅私有化需要获取appKey,secretKey免密登录
      if (!store.getters.isCloud) {
        if (window.location.href.includes('appKey') && window.location.href.includes('secretKey')) {
          setTimeout(() => {
            next()
          }, 800)
        } else {
          next('/Login')
        }
      } else {
        next('/Login')
      }
    }
  }
})

export default router
